import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/modules/gaushala/index";

export const Route = createFileRoute("/admin/_modules/_gaushala/gaushala")({
  component: Page,
});
